import React from "react";

export default function Alphabet() {
  return (
    <div className="columns">
      <div className="column">
        <div className="table-container">
          <table className="table is-hoverable is-striped is-bordered">
            <thead>
              <tr>
                <th>
                  <abbr title="Номер позиции">Индекс</abbr>
                </th>
                <th>
                  <abbr>Русская буква</abbr>
                </th>
                <th>
                  <abbr>Слово на английском</abbr>
                </th>
                <th>
                  <abbr>Слово на русском</abbr>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>1</th>
                <td>А а</td>
                <td>
                  B<span className="has-text-success">a</span>r
                </td>
                <td>
                  Б<span className="has-text-success">a</span>р
                </td>
              </tr>
              <tr>
                <th>2</th>
                <td>Б б</td>
                <td>
                  <span className="has-text-success">B</span>ar
                </td>
                <td>
                  <span className="has-text-success">Б</span>aр
                </td>
              </tr>
              <tr>
                <th>3</th>
                <td>В в</td>
                <td>
                  <span className="has-text-success">V</span>ector
                </td>
                <td>
                  <span className="has-text-success">B</span>ектор
                </td>
              </tr>
              <tr>
                <th>4</th>
                <td>Г г</td>
                <td>
                  <span className="has-text-success">G</span>arage
                </td>
                <td>
                  <span className="has-text-success">Г</span>араж
                </td>
              </tr>
              <tr>
                <th>5</th>
                <td>Д д</td>
                <td>
                  <span className="has-text-success">D</span>ocker
                </td>
                <td>
                  <span className="has-text-success">Д</span>окер
                </td>
              </tr>
              <tr>
                <th>6</th>
                <td>Е е</td>
                <td>
                  T<span className="has-text-success">e</span>xas
                </td>
                <td>
                  Т<span className="has-text-success">е</span>хас
                </td>
              </tr>
              <tr>
                <th>7</th>
                <td>Ё ё</td>
                <td>
                  S<span className="has-text-success">ur</span>fing
                </td>
                <td>
                  С<span className="has-text-success">ё</span>рфинг
                </td>
              </tr>
              <tr>
                <th>8</th>
                <td>Ж ж</td>
                <td>
                  Plea<span className="has-text-success">sure</span>
                </td>
                <td>
                  <span className="has-text-success">Ж</span>урнал
                </td>
              </tr>
              <tr>
                <th>9</th>
                <td>З з</td>
                <td>
                  <span className="has-text-success">Z</span>ebra
                </td>
                <td>
                  <span className="has-text-success">З</span>ебра
                </td>
              </tr>
              <tr>
                <th>10</th>
                <td>И и</td>
                <td>
                  <span className="has-text-success">E</span>lon
                </td>
                <td>
                  <span className="has-text-success">И</span>лон
                </td>
              </tr>
              <tr>
                <th>11</th>
                <td>Й й</td>
                <td>
                  Bo<span className="has-text-success">y</span>
                </td>
                <td>
                  <span className="has-text-success">Йойо</span>
                </td>
              </tr>
              <tr>
                <th>12</th>
                <td>К к</td>
                <td>
                  <span className="has-text-success">C</span>offe
                </td>
                <td>
                  <span className="has-text-success">К</span>офе
                </td>
              </tr>
              <tr>
                <th>13</th>
                <td>Л л</td>
                <td>
                  <span className="has-text-success">L</span>ist
                </td>
                <td>
                  <span className="has-text-success">Л</span>ист
                </td>
              </tr>
              <tr>
                <th>14</th>
                <td>М м</td>
                <td>
                  <span className="has-text-success">M</span>arker
                </td>
                <td>
                  <span className="has-text-success">М</span>аркер
                </td>
              </tr>
              <tr>
                <th>15</th>
                <td>Н н</td>
                <td>
                  <span className="has-text-success">Н</span>ос
                </td>
                <td>
                  <span className="has-text-success">N</span>ose
                </td>
              </tr>
              <tr>
                <th>16</th>
                <td>О о</td>
                <td>
                  Metr<span className="has-text-success">о</span>
                </td>
                <td>
                  Метр<span className="has-text-success">o</span>
                </td>
              </tr>
              <tr>
                <th>17</th>
                <td>П п</td>
                <td>
                  <span className="has-text-success">P</span>ark
                </td>
                <td>
                  П<span className="has-text-success">арк</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="column">
        <div className="table-container">
          <table className="table is-hoverable is-striped is-bordered">
            <thead>
              <tr>
                <th>
                  <abbr title="Номер позиции">Индекс</abbr>
                </th>
                <th>
                  <abbr>Русская буква</abbr>
                </th>
                <th>
                  <abbr>Слово на английском</abbr>
                </th>
                <th>
                  <abbr>Слово на русском</abbr>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>18</th>
                <td>Р р</td>
                <td>
                  <span className="has-text-success">R</span>оle
                </td>
                <td>
                  <span className="has-text-success">Р</span>оль
                </td>
              </tr>
              <tr>
                <th>19</th>
                <td>С с</td>
                <td>
                  <span className="has-text-success">S</span>port
                </td>
                <td>
                  <span className="has-text-success">С</span>порт
                </td>
              </tr>
              <tr>
                <th>20</th>
                <td>Т т</td>
                <td>
                  <span className="has-text-success">T</span>axi
                </td>
                <td>
                  <span className="has-text-success">Т</span>акси
                </td>
              </tr>
              <tr>
                <th>21</th>
                <td>У у</td>
                <td>
                  C<span className="has-text-success">oo</span>ler
                </td>
                <td>
                  К<span className="has-text-success">у</span>лер
                </td>
              </tr>
              <tr>
                <th>22</th>
                <td>Ф ф</td>
                <td>
                  <span className="has-text-success">F</span>ilm
                </td>
                <td>
                  <span className="has-text-success">Ф</span>ильм
                </td>
              </tr>
              <tr>
                <th>23</th>
                <td>Х х</td>
                <td>
                  <span className="has-text-success">H</span>ockey
                </td>
                <td>
                  <span className="has-text-success">Х</span>оккей
                </td>
              </tr>
              <tr>
                <th>24</th>
                <td>Ц ц</td>
                <td>
                  Pi<span className="has-text-success">zz</span>a
                </td>
                <td>
                  Пи<span className="has-text-success">цц</span>а
                </td>
              </tr>
              <tr>
                <th>25</th>
                <td>Ч ч</td>
                <td>
                  <span className="has-text-success">Ch</span>eck
                </td>
                <td>
                  <span className="has-text-success">Ч</span>ек
                </td>
              </tr>
              <tr>
                <th>26</th>
                <td>Ш ш</td>
                <td>
                  <span className="has-text-success">Sh</span>ow
                </td>
                <td>
                  <span className="has-text-success">Ш</span>оу
                </td>
              </tr>
              <tr>
                <th>27</th>
                <td>Щ щ</td>
                <td>
                  Bor<span className="has-text-success">sch</span>
                </td>
                <td>
                  Бор<span className="has-text-success">щ</span>
                </td>
              </tr>
              <tr>
                <th>28</th>
                <td>ъ</td>
                <td>
                  <span className="has-text-success">silent</span>
                </td>
                <td>
                  Об<span className="has-text-success">ъ</span>ект
                </td>
              </tr>
              <tr>
                <th>29</th>
                <td>ы</td>
                <td>
                  <span className="has-text-success">(no Eng)</span>
                </td>
                <td>
                  Муз<span className="has-text-success">ы</span>ка
                </td>
              </tr>
              <tr>
                <th>30</th>
                <td>ь</td>
                <td>
                  <span className="has-text-success">silent</span>
                </td>
                <td>
                  Цар<span className="has-text-success">ь</span>
                </td>
              </tr>
              <tr>
                <th>31</th>
                <td>Э э</td>
                <td>
                  <span className="has-text-success">E</span>dinburgh
                </td>
                <td>
                  <span className="has-text-success">Э</span>динбург
                </td>
              </tr>
              <tr>
                <th>32</th>
                <td>Ю ю</td>
                <td>
                  Prod<span className="has-text-success">u</span>cer
                </td>
                <td>
                  Прод<span className="has-text-success">ю</span>сер
                </td>
              </tr>
              <tr>
                <th>33</th>
                <td>Я я</td>
                <td>
                  <span className="has-text-success">Ya</span>ndex
                </td>
                <td>
                  <span className="has-text-success">Я</span>ндекс
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
